module.exports = __webpack_public_path__ + "img/connection-left-3.7164183f.png";